function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30798",
  "data-name": "Group 30798"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5218",
  "data-name": "Rectangle 5218",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5219",
  "data-name": "Rectangle 5219",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30800",
  "data-name": "Group 30800"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_30799",
  "data-name": "Group 30799"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59661",
  "data-name": "Path 59661",
  d: "M21,8a2,2,0,0,0-1.93,2.51l-3.55,3.56a2.037,2.037,0,0,0-1.04,0l-2.55-2.55a2,2,0,1,0-3.86,0L3.51,16.07a2,2,0,1,0,1.42,1.42l4.55-4.56a2.037,2.037,0,0,0,1.04,0l2.55,2.55a2,2,0,1,0,3.86,0l3.56-3.55A2,2,0,1,0,21,8Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59662",
  "data-name": "Path 59662",
  d: "M15,9l.94-2.07L18,6l-2.06-.93L15,3l-.92,2.07L12,6l2.08.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59663",
  "data-name": "Path 59663",
  d: "M3.5,11,4,9l2-.5L4,8,3.5,6,3,8,1,8.5,3,9Z"
})));

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insights_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.9508ccf5.svg";
export { ForwardRef as ReactComponent };